module.exports = __webpack_public_path__ + "img/girl-and-pet.eed1c678.png";